//import modules
import APIFetch from './APIFetch';

export default APIFetch;
